import { Badge } from "@/components/ui/badge";
import { InstanceStatus, SecondaryInstanceStatus } from "@/lib/api/checklist";
import { cn } from "@/lib/utils";

interface StatusIndicatorProps {
  status: InstanceStatus;
  secondary_status?: SecondaryInstanceStatus;
  className?: string;
}

export function StatusIndicator({ secondary_status, status, className }: StatusIndicatorProps) {
    const getStatusColor = (status: InstanceStatus) => {
    switch (status) {
      case InstanceStatus.PENDING:
        return "bg-blue-100 text-blue-800 hover:bg-blue-200";
      case InstanceStatus.COMPLETED:
        return "bg-green-100 text-green-800 hover:bg-green-200";
      case InstanceStatus.CANCELLED:
        return "bg-gray-100 text-gray-800 hover:bg-gray-200";
      default:
        return "bg-gray-100 text-gray-800 hover:bg-gray-200";
    }
  };

  return (
    <Badge 
      variant="secondary" 
      className={cn(getStatusColor(status), className)}
    >
      {secondary_status === SecondaryInstanceStatus.NonAppl ? "NON-APPL" : status }
    </Badge>
  );
}
